'use client';

export default function GlobalError({
  _reset,
}: {
  error: Error & { digest?: string };
  _reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#070707] text-white">
          <h1 className="text-4xl font-bold mb-4">Something went wrong</h1>
          <p className="text-[#999] mb-6">An unexpected error occurred</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-[#1fd5f9] text-[#000] rounded-lg hover:bg-[#1fd5f9]/90 transition-colors"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
